import { disablePageScroll, enablePageScroll } from 'scroll-lock';

export function isMobile() {
    return window.innerWidth < 768;
}

export function showPanel(panelEl, backdropEl) {
    if (panelEl) panelEl.classList.add('is-visible');
    if (backdropEl) backdropEl.classList.add('is-visible');
    if (isMobile()) disablePageScroll(document.body);
}

export function hideAllPanels(panelEls, backdropEl) {
    panelEls.forEach(p => p.classList.remove('is-visible'));
    if (backdropEl) backdropEl.classList.remove('is-visible');
    if (isMobile()) enablePageScroll(document.body);
}
